import { writable, derived } from "svelte/store";

const createConnection = () => {
  const { subscribe, set } = writable();

  return { subscribe, set }
}
export const connection = createConnection();

export const chainId = derived(connection, $connection => $connection?.chain?.chain.id);
export const chainName = derived(connection, $connection => $connection?.chain?.chain.name);
export const chainSymbol = derived(connection, $connection => $connection?.chain?.chain.nativeCurrency.symbol);
export const chainExplorer = derived(connection, $connection => $connection?.chain?.chain.blockExplorers.default);
export const walletAddress = derived(connection, $connection => $connection?.account);
export const walletName = derived(connection, $connection => $connection?.connector?.name);
